import React, { useState, useEffect, useContext } from "react";
import BuildRatio from "./progressBars/buildRatio";
import ProgressCircle from "./progressBars/circle";
import ImgTooltip from "./pokemonImg/imgTooltip";
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { AppConfigContext, axios_timeout } from "../Config/App";
import LoadingAnimation from "./loadingAnimation";
import uuid from "uuidv4";
import { useParams } from "react-router-dom";
import BtnRounded from "./btn/btnRounded";
import { LanguageContext } from "../Data/Context/languageContext";

const LatestBuilds = () => {
  const { api_url, assets_url, navigate_to } = useContext(AppConfigContext);
  const [latestBuilds, setLatestBuilds] = useState([]);
  const [bestBuilds, setBestBuilds] = useState([]);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const { pokemon_name } = useParams();
  const { t } = useContext(LanguageContext);

  useEffect(() => {
    setIsLoaded(false);

    pokemon_name ? getBestBuilds() : getLatest();
    // eslint-disable-next-line
  }, [pokemon_name]);

  const getLatest = () => {
    Axios.get(api_url("latest-builds"), { timeout: axios_timeout })
      .then((response) => {
        if(response.status === 200) setLatestBuilds(response.data);
      })
      .catch((err) => {
        console.log(err.code, err.stack, err.message);
      });

    setTimeout(() => {
      setIsLoaded(true);
    }, 500);
  };

  const getBestBuilds = () => {
    let pokemon_name_parsed;

    pokemon_name_parsed = pokemon_name
      .replaceAll("-", " ")
      .replaceAll("ho oh", "ho-oh")
      .replaceAll("kommo o", "kommo-o")
      .replaceAll("hakamo o", "hakamo-o")
      .replaceAll("jangmo o", "jangmo-o")
      .replaceAll("porygon z", "porygon-z");

    Axios.get(api_url("best-builds/" + pokemon_name_parsed), {
      timeout: axios_timeout,
    })
      .then((response) => {
        if (!response.data) setBestBuilds([]);

        if (response.data) setBestBuilds(response.data);
      })
      .catch((err) => {
        console.log(err.code, err.stack, err.message);
      });

    setTimeout(() => {
      setIsLoaded(true);
    }, 500);
  };

  return (
    <div className="col-lg-8 col-xxl-9 ps-0 ps-lg-4">
      {!isLoaded && <LoadingAnimation />}

      {pokemon_name &&
        isLoaded &&
        bestBuilds.length === 0 && ( // If no best builds
          <>
            <div className="col-12 col-sm-10 col-md-6 col-lg-8 col-xl-6 mx-auto text-center">
              <img
                loading="lazy"
                className="img-fluid"
                src={assets_url("no-builds.webp")}
                alt="alt"
              ></img>
              <Link to={navigate_to("new-build")}>
                <BtnRounded classes={"mt-4"}>
                  {t("create_build_for")}
                </BtnRounded>
              </Link>
            </div>
          </>
        )}

      {!pokemon_name &&
        isLoaded &&
        latestBuilds.length > 0 && ( // If latest builds
          <>
            <div className="row" id="latest-builds">
              {latestBuilds.map((build) => {
                return (
                  <div
                    key={uuid()}
                    onClick={() => navigate(navigate_to(`build/${build.id}`))}
                    className="build-info mb-3 purple-bk-lighter custom-border rounded-3 py-1"
                  >
                    <div className="row my-2">
                      <div className="col-12 col-sm-7 col-md-6 col-lg-7 col-xxl-5 d-flex justify-content-center justify-content-sm-start align-items-center">
                        <div className="d-none d-sm-flex">
                          <BuildRatio
                            likes={+build.likes}
                            dislikes={+build.dislikes}
                          />
                        </div>
                        <ProgressCircle
                          likes={+build.likes}
                          dislikes={+build.dislikes}
                        >
                          <img
                            loading="lazy"
                            className="pokemon-ratio-img"
                            src={assets_url(
                              "pokedex/thumbnails/" + build.picture
                            )}
                            alt={"Pokeland Legends " + build.name}
                          ></img>
                        </ProgressCircle>
                        <div id="build-info">
                          <p className="mb-1">
                            {build.title ? build.title : build.name}
                          </p>
                          <p>
                            {t("created_at")}: {build.created_at.split("T")[0]}
                          </p>
                          <p>
                            {t("created_by")}: {build.username}
                            <img
                              className="name-flag"
                              src={assets_url(`flags/${build.version}.webp`)}
                              alt="Pokeland Legends Builder"
                            ></img>
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-3 d-flex flex-sm-column align-items-center justify-content-center ms-md-auto my-2 my-sm-0">
                        {build.teammate_1 ||
                        build.teammate_2 ||
                        build.teammate_3 ||
                        build.teammate_4 ? (
                          <>
                            <div className="me-3 me-sm-0">
                              {build.teammate_1 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_1
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                              {build.teammate_2 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_2
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                            </div>
                            <div>
                              {build.teammate_3 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_3
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                              {build.teammate_4 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_4
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                            </div>
                          </>
                        ) : (
                          <p className="mb-0">{t("no_teammates")}</p>
                        )}
                      </div>

                      <div className="d-flex d-sm-none">
                        <BuildRatio
                          likes={+build.likes}
                          dislikes={+build.dislikes}
                        />
                      </div>

                      <div className="d-none d-sm-flex col-12 col-sm-2 d-flex flex-sm-column align-items-center justify-content-center ms-md-auto">
                        <span className="m-1">
                          <i className="fa-solid fa-thumbs-up"></i>{" "}
                          {+build.likes}{" "}
                        </span>
                        <p className="m-1">{t("votes")}</p>
                        <span className="m-1">
                          <i className="fa-solid fa-thumbs-down"></i>{" "}
                          {+build.dislikes}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

      {pokemon_name &&
        isLoaded &&
        bestBuilds.length > 0 && ( // If best builds
          <>
            <div className="row" id="latest-builds">
              {bestBuilds.map((build) => {
                return (
                  <div
                    key={uuid()}
                    onClick={() => navigate(navigate_to(`build/${build.id}`))}
                    className="build-info mb-3 purple-bk-lighter custom-border rounded-3 py-1"
                  >
                    <div className="row my-2">
                      <div className="col-12 col-sm-7 col-md-6 col-lg-7 col-xxl-5 d-flex justify-content-center justify-content-sm-start align-items-center">
                        <div className="d-none d-sm-flex">
                          <BuildRatio
                            likes={+build.likes}
                            dislikes={+build.dislikes}
                          />
                        </div>
                        <ProgressCircle
                          likes={+build.likes}
                          dislikes={+build.dislikes}
                        >
                          <img
                            loading="lazy"
                            className="pokemon-ratio-img"
                            src={assets_url(
                              "pokedex/thumbnails/" + build.picture
                            )}
                            alt={"Pokeland Legends " + build.name}
                          ></img>
                        </ProgressCircle>
                        <div id="build-info">
                          <p className="mb-1">
                            {build.title ? build.title : build.name}
                          </p>
                          <p>
                            {t("created_at")}: {build.created_at.split("T")[0]}
                          </p>
                          <p>
                            {t("created_by")}: {build.username}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-3 d-flex flex-sm-column align-items-center justify-content-center ms-md-auto my-2 my-sm-0">
                        {build.teammate_1 ||
                        build.teammate_2 ||
                        build.teammate_3 ||
                        build.teammate_4 ? (
                          <>
                            <div className="me-3 me-sm-0">
                              {build.teammate_1 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_1
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                              {build.teammate_2 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_2
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                            </div>
                            <div>
                              {build.teammate_3 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_3
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                              {build.teammate_4 && (
                                <ImgTooltip
                                  classes="team-mate-border border-small m-1 img-fluid"
                                  src={
                                    assets_url("pokedex/thumbnails/") +
                                    build.teammate_4
                                  }
                                  alt={"Pokeland Legends " + build.name}
                                ></ImgTooltip>
                              )}
                            </div>
                          </>
                        ) : (
                          <p className="mb-0">{t("no_teammates")}</p>
                        )}
                      </div>

                      <div className="d-flex d-sm-none">
                        <BuildRatio
                          likes={+build.likes}
                          dislikes={+build.dislikes}
                        />
                      </div>

                      <div className="d-none d-sm-flex col-12 col-sm-2 d-flex flex-sm-column align-items-center justify-content-center ms-md-auto">
                        <span className="m-1">
                          <i className="fa-solid fa-thumbs-up"></i>{" "}
                          {+build.likes}{" "}
                        </span>
                        <p className="m-1">{t("votes")}</p>
                        <span className="m-1">
                          <i className="fa-solid fa-thumbs-down"></i>{" "}
                          {+build.dislikes}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
    </div>
  );
};
export default React.memo(LatestBuilds);
